import useIsRtl from "@/hooks/useIsRtl";

const SvgAppointmentGo = () => {
  const isRTL = useIsRtl();
  return (
    <svg
      style={{ transform: isRTL ? "" : "scaleX(-1)", marginInlineStart: 8 }}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18227_34390)">
        <path
          d="M12.4883 2.39412C12.3324 2.39877 12.1845 2.46391 12.0758 2.57576L6.07581 8.57576C5.96333 8.68829 5.90015 8.84088 5.90015 8.99998C5.90015 9.15908 5.96333 9.31167 6.07581 9.4242L12.0758 15.4242C12.1311 15.4818 12.1973 15.5278 12.2706 15.5594C12.3439 15.5911 12.4227 15.6078 12.5026 15.6086C12.5824 15.6095 12.6616 15.5943 12.7355 15.5642C12.8094 15.534 12.8765 15.4894 12.933 15.4329C12.9894 15.3765 13.034 15.3093 13.0642 15.2354C13.0944 15.1615 13.1095 15.0823 13.1087 15.0025C13.1079 14.9227 13.0912 14.8438 13.0595 14.7705C13.0278 14.6973 12.9818 14.631 12.9242 14.5758L7.34847 8.99998L12.9242 3.4242C13.011 3.33992 13.0702 3.23142 13.0941 3.1129C13.1181 2.99439 13.1057 2.8714 13.0586 2.76005C13.0115 2.6487 12.9318 2.55418 12.8301 2.48888C12.7283 2.42359 12.6092 2.39056 12.4883 2.39412Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_18227_34390">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAppointmentGo;
